import { TokenizersRegex } from '../tokenizers/tokenizers'

const markdownRegexToRemove = [TokenizersRegex.bold, TokenizersRegex.header]
/**
 * Removes certain markdown formatting in markdownRegexToRemove and returns only the plain text content.
 * Uses the regex patterns from TokenizersRegex for consistency.
 *
 * @param text - Markdown-formatted text
 * @returns Plain text with markdown formatting removed
 */
export const removeMarkdown = (text: string): string => {
  if (!text) {
    return ''
  }

  let textWithoutMarkdown = text
  for (const regex of markdownRegexToRemove) {
    textWithoutMarkdown = textWithoutMarkdown.replaceAll(new RegExp(regex, 'g'), '$1')
  }
  return textWithoutMarkdown.trim()
}
